export default {"src":"/_next/static/media/upload2.041d1439.svg","height":41,"width":262,"blurWidth":0,"blurHeight":0};